import type { ComponentProps, ReactNode } from "react"
import {
  Tooltip as BaseTooltip,
  TooltipContent,
  TooltipTrigger,
} from "../components/ui/tooltip"

type Props = Pick<ComponentProps<typeof TooltipContent>, "side"> & {
  children: ReactNode & ComponentProps<typeof TooltipTrigger>["render"]
  tooltip?: string
}

export default function Tooltip({ children, tooltip, side }: Props) {
  return tooltip ? (
    <BaseTooltip>
      <TooltipTrigger render={children} />
      <TooltipContent side={side}>
        <p>{tooltip}</p>
      </TooltipContent>
    </BaseTooltip>
  ) : (
    children
  )
}
